const getMinParams = (params: [string | number] | { min: string | number }): { min: number } => {
    if (!params) {
        return { min: 0 };
    }
    if (Array.isArray(params)) {
        return { min: Number(params[0]) };
    }
    return {
        min: Number(params.min),
    };
}

const getMaxParams = (params: [string | number] | { max: string | number }): { max: number } => {
    if (!params) {
        return { max: 0 };
    }
    if (Array.isArray(params)) {
        return { max: Number(params[0]) };
    }
    return {
        max: Number(params.max),
    };
}

const getMultipleParams = (params: [string | number] | { multiple: string | number }): { multiple: number } => {
    if (!params) {
        return { multiple: 0 };
    }
    if (Array.isArray(params)) {
        return { multiple: Number(params[0]) };
    }
    return {
        multiple: Number(params.multiple),
    };
}

const minLengthValidator = (value: unknown, params: [string | number] | { min: string | number }): boolean => {
    const { min } = getMinParams(params)

    if (!value) return false
    if (Array.isArray(value)) {
        if (value.length < min) {
            return false
        }
    }
    return true
}

const maxLengthValidator = (value: unknown, params: [string | number] | { max: string | number }): boolean => {
    const { max } = getMaxParams(params)

    if (!value) return false
    if (Array.isArray(value)) {
        if (value.length > max) {
            return false
        }
    }
    return true
}

const multipleValidator = (value: unknown, params: [string | number] | { multiple: string | number }): boolean => {
    const { multiple } = getMultipleParams(params)

    if (typeof value !== 'number') return false

    return value % multiple === 0;
}

export {
    minLengthValidator,
    maxLengthValidator,
    multipleValidator
}
